export default __webpack_public_path__ + "static/media/newspapercuttinginvestors.14c57721.png";